import { useCallback, useEffect, useState } from 'react';
export const STORAGE_READ_NOTIFICATIONS_KEY = 'platformNotifications:readNotifications';
export const useReadPlatformNotifications = () => {
    const getStorageReadNotifications = () => {
        try {
            const stringifiedResult = localStorage.getItem(STORAGE_READ_NOTIFICATIONS_KEY);
            if (!stringifiedResult) {
                return [];
            }
            return JSON.parse(stringifiedResult);
        }
        catch (e) {
            console.error('unable to parse localstorage item', e, STORAGE_READ_NOTIFICATIONS_KEY);
            return [];
        }
    };
    const [readNotificationsIds, setReadNotificationsIds] = useState(getStorageReadNotifications());
    useEffect(() => {
        const listener = () => {
            setReadNotificationsIds(getStorageReadNotifications());
        };
        window.addEventListener('STORAGE_READ_NOTIFICATIONS_KEY', listener);
        return () => window.removeEventListener('STORAGE_READ_NOTIFICATIONS_KEY', listener);
    }, []);
    const isNotificationRead = useCallback((notificationId) => readNotificationsIds.includes(notificationId), [readNotificationsIds]);
    const readNotification = (notificationId) => {
        const prevState = getStorageReadNotifications();
        const newState = [...prevState, notificationId];
        localStorage.setItem(STORAGE_READ_NOTIFICATIONS_KEY, JSON.stringify(newState));
        window.dispatchEvent(new Event('STORAGE_READ_NOTIFICATIONS_KEY'));
    };
    return {
        readNotification,
        isNotificationRead,
        readNotificationsIds,
    };
};
//# sourceMappingURL=useReadPlatformNotifications.js.map